import React, {useEffect, useRef} from 'react';
import marked from './parseMarkdown';
import classes from 'classnames';
import {Classes} from "@blueprintjs/core";
import emitter from "../../utils/emitter";

const Markdown = ({ content = '', loading=false }) => {
  const container = useRef();
  useEffect(() => {
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.querySelectorAll('pre.bp3-code-block').forEach(block => {
        window.hljs.highlightBlock(block);
      });
      container.current.querySelectorAll('.code-block-runner-trigger').forEach(trigger => {
        trigger.addEventListener('click', handleRunBlockCode);
      });
    }, 100);
  }, [content]);
  const handleRunBlockCode = (e) => {
    emitter.emit('run-block-code', decodeURIComponent(e.currentTarget.dataset['code']));
  };
  return (
    <div className={classes(loading && Classes.SKELETON)} dangerouslySetInnerHTML={{ __html:  marked(content)}} ref={container} />
  );
};

export default Markdown;
